import React, { useMemo } from "react";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router";
import { Spinner } from "reactstrap";
import { useGetOneMakkahGroupQuery } from "../../../services/groups";
import { MakkahGroupForm } from "./MakkahGroupForm";
import { Edit02Icon } from "@hugeicons/core-free-icons/index";
import { HugeiconsIcon } from "@hugeicons/react";
import BtnAsLink from "@/Component/BtnAsLink";
import { Stack } from "react-bootstrap";
import { useSystem } from "@/utils/hooks/useLocation";
import { permissions } from "@/utils/constants";
import { Can } from "@/CommonElements/PermissionGate";

const UpdateGroup = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  const { mode } = useParams();
  const { currentSystem } = useSystem();
  const isMadina = currentSystem === "madina";
  const canAmend = mode === "edit" || mode === "create";

  // Fetch group data
  const {
    data: groupRes,
    isLoading: groupLoading,
    isFetching: groupFetching,
    isError: groupError,
  } = useGetOneMakkahGroupQuery();

  const loading = groupLoading || groupFetching;

  const groupData = useMemo(
    () => groupRes?.data?.data || {},
    [groupRes]
  );
  const groupDetails =
    groupData.details || groupData.arrival_group_details || [];

  if (loading) {
    return (
      <div>
        <PageHeader title={t("GROUPS_FORM_ADD_GROUP_DETAILS")} />
        <div className="m-4 text-center py-5">
          <Spinner />
          <p className="mt-3">{t("LOADING")}</p>
        </div>
      </div>
    );
  }

  if (groupError) {
    return (
      <div>
        <PageHeader title={t("GROUPS_FORM_ADD_GROUP_DETAILS")} />
        <div className="m-4 text-center py-5">
          <p className="text-danger">{t("ERROR_LOADING_GROUP")}</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <PageHeader
        title={t(canAmend ? "GROUPS_FORM_ADD_GROUP_DETAILS" : "GROUP_DETAILS")}
      >
        {!canAmend && (
          <Stack direction="horizontal" gap={2}>
            <Can
              permissions={[
                isMadina ? permissions.update_groups_for_madina : permissions.update_groups
              ]}
            >
              <BtnAsLink
                icon={<HugeiconsIcon icon={Edit02Icon} />}
                className="btn btn-primary"
                link={`/app/${currentSystem}/basic-data/groups-upcoming/${id}/edit`}
              >
                {t("EDIT_GROUP")}
              </BtnAsLink>
            </Can>
            <Can
              permissions={[
                isMadina
                  ? permissions.create_group_details_for_madina
                  : permissions.create_group_details
              ]}
            >
              <BtnAsLink
                icon={<HugeiconsIcon icon={Edit02Icon} />}
                className="btn btn-outline-primary"
                link={`/app/${currentSystem}/groups-upcoming/${id}/edit`}
              >
                {t("GROUPS_FORM_ADD_DETAILS")}
              </BtnAsLink>
            </Can>
          </Stack>
        )}
      </PageHeader>

      <div className="m-4">
        <MakkahGroupForm
          groupDetails={groupDetails}
          initialGroupData={groupData}
        />
      </div>
    </div>
  );
};

export default UpdateGroup;
